import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export type BenchmarkScoreGrade = 'A' | 'B' | 'C' | 'D';

export function gradeFromScore(score: number): BenchmarkScoreGrade {
  if (!Number.isFinite(score)) return 'D';
  if (score >= 85) return 'A';
  if (score >= 70) return 'B';
  if (score >= 50) return 'C';
  return 'D';
}
